<template>
  <div id="mapContainer" class="mapContainer">
    <div id="socializationMap" class="map"></div>
  </div>
</template>

<script>
// import GIS_MAP from "@/assets/JSON/gisMap";
import { getMapSeting } from "@/api/ai.js";
import { fromLonLat } from "ol/proj";
import Map from "ol/Map";
import Feature from "ol/Feature";
import Overlay from "ol/Overlay";
import Point from "ol/geom/Point";
import Cluster from "ol/source/Cluster";
import { Tile as TileLayer } from "ol/layer";
import DragPan from "ol/interaction/DragPan";
import VectorSource from "ol/source/Vector";
import { Vector as VectorLayer } from "ol/layer";
import { XYZ } from "ol/source";
import View from "ol/View";
import GeoJSON from "ol/format/GeoJSON.js";
import { TileSuperMapRest } from "@supermap/iclient-ol";
import { defaults as defaultControls } from "ol/control";
import { Style, Icon, Stroke, Circle, Fill, Text } from "ol/style";
var _toolType = [64, 71, 81, 100, 101, 102];
import { getStationListByRadius } from "@/api/socialization";
import infowindow from "./infowindow";
import pointWindow from "./pointWindow";
import clusterWindow from "./clusterWindow";
import Vue from "vue";
import { over } from "lodash";

export default {
  props: {
    // 选择那些类型
    typeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      layers: {
        baseLayer: null,
      },
      openConsole: false,
      country: [],
      provinces: [],
      cities: [],
      counties: [],
      towns: [],
      overlays: [], // 存储所有 Overlay
      moveCount: 0, // 记录移动次数
      levelZoom: {
        0: 4,
        1: 6.5,
        2: 9.7,
        3: 11.4,
        4: 12.5,
      },
      lastZoomLevel: 2, // 上一次的缩放级别
      pointOverlays: [], // 点位信息
      winZIndex: 99, // 解决overlay层级问题
      mapSeting: null,
    };
  },
  mounted() {
    this.initMap();
    // 监听ctr+m
    this.keydownHandler = window.addEventListener("keydown", (event) => {
      if (event.ctrlKey && event.key === "m") {
        // 按下了 Ctrl + M 键
        this.openConsole = !this.openConsole;
      }
    });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.setTarget(null);
      this.map = null;
    }
  },
  computed: {},
  methods: {
    /** 重置新绘制聚合点 */
    async resetAreaCount(areas = []) {
      let materialStationNums = 0;
      let repairStationNums = 0;
      let sellingStationNums = 0;
      let driverNums = 0;
      let gasStationNums = 0;
      let helperNums = 0;
      let totalNums = 0;
      let transportStationNums = 0;
      let grainNums = 0;
      areas.map((v) => {
        materialStationNums += Number(v.materialStationNums);
        repairStationNums += Number(v.repairStationNums);
        sellingStationNums += Number(v.sellingStationNums);
        driverNums += Number(v.driverNums);
        gasStationNums += Number(v.gasStationNums);
        helperNums += Number(v.helperNums);
        totalNums += Number(v.totalNums);
        transportStationNums += Number(v.transportStationNums);
        grainNums += Number(v.grainNums);
      });
      const areasDatas = [
        {
          areaName: "全国",
          areaCode: "100000",
          areaId: "100000",
          subArea: areas,
          latitude: 35.0,
          longitude: 104.0,
          materialStationNums: materialStationNums,
          repairStationNums: repairStationNums,
          sellingStationNums: sellingStationNums,
          driverNums: driverNums,
          gasStationNums: gasStationNums,
          helperNums: helperNums,
          totalNums: totalNums,
          transportStationNums: transportStationNums,
          grainNums: grainNums,
        },
      ];
      let self = this;
      await self.clearOverlays();
      // 初始化空数组，用于存储分离后的各级区域数据
      const [country, provinces, cities, counties, towns] = [
        [],
        [],
        [],
        [],
        [],
      ];
      // 递归函数，用于遍历和分离数据
      function separateAreas(data, level = 1, parent) {
        data.forEach((item) => {
          // 坐标类型转换,必要,在动画移动必须number类型
          item.latitude = Number(item.latitude);
          item.longitude = Number(item.longitude);
          const {
            areaName,
            areaCode,
            longitude,
            latitude,
            subArea,
            materialStationNums,
            repairStationNums,
            sellingStationNums,
            driverNums,
            gasStationNums,
            helperNums,
            totalNums,
            transportStationNums,
            grainNums,
            workNums,
          } = item;
          // // 机手
          // 根据层级添加到对应的数组
          if (longitude && latitude) {
            if (level === 0) {
              if (longitude && latitude) {
                country.push({
                  areaName,
                  areaCode,
                  longitude,
                  latitude,
                  subArea,
                  materialStationNums,
                  repairStationNums,
                  sellingStationNums,
                  driverNums,
                  gasStationNums,
                  helperNums,
                  totalNums,
                  transportStationNums,
                  grainNums,
                  workNums,
                  parent: parent,
                });
                // provinceOverlays.push(overlay);
              }
            } else if (level === 1) {
              if (longitude && latitude) {
                provinces.push({
                  areaName,
                  areaCode,
                  longitude,
                  latitude,
                  subArea,
                  materialStationNums,
                  repairStationNums,
                  sellingStationNums,
                  driverNums,
                  gasStationNums,
                  helperNums,
                  totalNums,
                  transportStationNums,
                  grainNums,
                  workNums,
                  parent: parent,
                });
                // provinceOverlays.push(overlay);
              }
            } else if (level === 2) {
              if (item.areaName !== "省直辖市") {
                if (longitude && latitude) {
                  cities.push({
                    areaName,
                    areaCode,
                    longitude,
                    latitude,
                    subArea,
                    materialStationNums,
                    repairStationNums,
                    sellingStationNums,
                    driverNums,
                    gasStationNums,
                    helperNums,
                    totalNums,
                    transportStationNums,
                    grainNums,
                    workNums,
                    parent: parent,
                  });
                }
                // cityOverlays.push(overlay);
              }
            } else if (level === 3) {
              if (longitude && latitude) {
                counties.push({
                  areaName,
                  areaCode,
                  longitude,
                  latitude,
                  subArea,
                  materialStationNums,
                  repairStationNums,
                  sellingStationNums,
                  driverNums,
                  gasStationNums,
                  helperNums,
                  totalNums,
                  transportStationNums,
                  grainNums,
                  workNums,
                  parent: parent,
                });
                // countyOverlays.push(overlay);
              }
            } else if (level === 4) {
              towns.push({
                areaName,
                areaCode,
                longitude,
                latitude,
                subArea,
                materialStationNums,
                repairStationNums,
                sellingStationNums,
                driverNums,
                gasStationNums,
                helperNums,
                totalNums,
                transportStationNums,
                grainNums,
                workNums,
                parent: parent,
              });
            }
          }

          // 递归处理下一层
          if (subArea && subArea.length > 0) {
            separateAreas(
              subArea,
              level + 1,
              Object.assign(item, { subArea: null })
            );
          } else {
            if (level == 3) {
              // 县区，没有子级情况下，自己当自己子级
              separateAreas(
                [
                  {
                    areaName,
                    areaCode,
                    longitude,
                    latitude,
                    subArea,
                    materialStationNums,
                    repairStationNums,
                    sellingStationNums,
                    driverNums,
                    gasStationNums,
                    helperNums,
                    totalNums,
                    transportStationNums,
                    grainNums,
                    workNums,
                    subArea,
                  },
                ],
                level + 1,
                Object.assign(item, { subArea: null })
              );
            }
          }
        });
      }
      // 开始分离数据
      separateAreas(areasDatas, 0);

      this.country = country;
      this.provinces = provinces;
      this.cities = cities;
      this.counties = counties;
      this.towns = towns;
      await this.clearOverlays();
      this.closeWindow();
      this.onMapMove();
    },
    /**
     * 清除所有聚合overlay
     */
    async clearOverlays() {
      this.overlays.forEach((overlay) => {
        this.map.removeOverlay(overlay);
      });
      this.overlays = [];
    },
    /**
     * 如果点在视图内，输出 true，否则输出 false。point: [x, y], viewport: { topLeft: [x1, y1], bottomRight: [x2, y2] }
     */
    isCoordinateInViewport(point, viewport) {
      const [x, y] = point;
      const { topLeft, bottomRight } = viewport;
      const [x1, y1] = topLeft;
      const [x2, y2] = bottomRight;
      return x >= x1 && x <= x2 && y >= y1 && y <= y2;
    },
    /** 获取所有省市县乡镇的overlay */
    async updateOverlays(level, upOrDown) {
      if (!this || !this.map) {
        return;
      }
      let data = [];
      if (level === 0) {
        data = this.country;
      } else if (level === 1) {
        data = this.provinces;
      } else if (level === 2) {
        data = this.cities;
      } else if (level === 3) {
        data = this.counties;
      } else if (level === 4) {
        data = this.towns;
      }
      if (data) {
        if (upOrDown == "up") {
          this.moveCount = 0;
          this.overlays.forEach((overlay, index) => {
            this.animate(overlay, upOrDown);
          });
        } else {
          await this.clearOverlays();
          let location = this.map.getView().calculateExtent(this.map.getSize());
          var position;
          //  过滤可视区域内Overlay
          data.forEach((item) => {
            if (upOrDown === "down" && item.parent) {
              position = [item.parent.longitude, item.parent.latitude]; // 转换为投影坐标
            } else if (upOrDown === "up") {
              position = [item.longitude, item.latitude]; // 转换为投影坐标
            } else {
              position = [item.longitude, item.latitude]; // 转换为投影坐标
            }
            if (
              this.isCoordinateInViewport([item.longitude, item.latitude], {
                topLeft: [location[0], location[1]],
                bottomRight: [location[2], location[3]],
              })
            ) {
              const Content = Vue.extend(clusterWindow);
              let element = new Content({
                propsData: {
                  clusterInfo: item,
                  typeList: this.typeList,
                  vmm: this,
                },
              }).$mount();
              const overlay = new Overlay({
                element: element.$el,
                position: position,
                offset: [0, 10],
                stopEvent: false,
              });
              overlay.set("data", item); // 将数据存储到 Overlay 中
              overlay.setPositioning("bottom-center");
              // 绑定 click 事件
              overlay.getElement().addEventListener("click", (event) => {
                event.stopPropagation(); // 阻止事件冒泡到地图
                let addLevel = 1;
                if (level == 4) addLevel = 0.3; // 乡镇不下钻太狠
                this.map.getView().animate({
                  center: [item.longitude, item.latitude],
                  zoom: this.levelZoom[level] + addLevel,
                  duration: 400,
                });
              });
              // 解决overlay层级被遮挡问题
              overlay.getElement().addEventListener("mouseenter", (event) => {
                overlay.getElement().parentNode.style.zIndex =
                  this.winZIndex += 6;
              });
              // 解决overlay层级被遮挡问题
              overlay.getElement().addEventListener("mouseleave", (event) => {
                overlay.getElement().parentNode.style.zIndex =
                  this.winZIndex += 4;
              });
              this.map.addOverlay(overlay);
              this.overlays.push(overlay);
              if (upOrDown) {
                this.animate(overlay, upOrDown);
              }
            }
          });
        }
      }
    },
    initMap() {
      let self = this;
      this.map = new Map({
        target: "socializationMap",
        layers: [
          new TileLayer({
            source: new XYZ({
              url: "https://t{0-7}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileCol={x}&TileRow={y}&TileMatrix={z}&tk=1d109683f4d84198e37a38c442d68311",
            }),
            isGroup: true,
            name: "高德图路网",
          }),
          new TileLayer({
            source: new TileSuperMapRest({
              url: this.$utils.formatUrl(
                "https://gis-server.chiaic.com/iserver/services/map-HeNanShengWeiXingDiTu/rest/maps/%E4%B8%AD%E5%9B%BD%E8%92%99%E6%9D%BF"
              ),
              cacheEnabled: true,
            }),
            isGroup: true,
            name: "蒙版",
            type: "baseLyer",
          }),
          new TileLayer({
            zIndex: 10,
            source: new TileSuperMapRest({
              url: this.$utils.formatUrl(
                "https://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国矢量数据"
              ),
              cacheEnabled: true,
            }),
            isGroup: true,
            name: "全国省矢量",
            type: "baseLyer",
          }),
          new TileLayer({
            zIndex: 10,
            source: new TileSuperMapRest({
              url: this.$utils.formatUrl(
                "https://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国省界"
              ),
              cacheEnabled: true,
            }),
            isGroup: true,
            name: "全国省界",
            type: "baseLyer",
          }),
        ],
        controls: defaultControls({
          attribution: false,
        }),
        view: new View({
          center: [113.21, 33.88],
          zoom: 7,
          projection: "EPSG:4326",
          maxZoom: 14,
          minZoom: 7,
        }),
      });
      this.addProvince();
      let pan = this.getPan();
      pan.setActive(true);
      this.map.getView().on("change:resolution", this.onZoomChange);
      this.map.on("moveend", this.onMapMove);
      this.map.on("singleclick", (e) => {
        this.closeWindow();
      });
    },
    onMapMove() {
      if (!this.isMoving) {
        if (this.lastZoomLevel == 5) this.getPointList();
        this.updateOverlays(this.lastZoomLevel);
      }
    },
    onZoomChange(level) {
      let that = this;
      const zoom = this.map.getView().getZoom();
      const center = this.map.getView().getCenter();
      console.log("zoom :>> ", zoom, center);
      function getLevelByZoom(zoom) {
        if (zoom < that.levelZoom[0]) {
          return 0;
        }
        if (zoom < that.levelZoom[1]) {
          return 1;
        }
        if (zoom < that.levelZoom[2]) {
          return 2;
        }
        if (zoom < that.levelZoom[3]) {
          return 3;
        }
        if (zoom < that.levelZoom[4]) {
          return 4;
        }
        return 5;
      }
      const levelx = getLevelByZoom(zoom);
      if (levelx == 5) {
        this.lastZoomLevel = levelx;
        // 清除聚合信息
        this.clearOverlays();
        return;
      } else {
        // 清除overlay弹框
        this.closeWindow();
        // 清除点位信息
        this.clearPointOverlays();
      }
      if (levelx !== this.lastZoomLevel) {
        const upOrDown = levelx > this.lastZoomLevel ? "down" : "up";
        this.lastZoomLevel = levelx;
        this.updateOverlays(levelx, upOrDown);
      }
    },
    /**
     * 动画执行
     * @param overlay 要执行的overlay
     * @param upOrDown 是上浮还是下沉
     */
    animate(overlay, upOrDown) {
      const data = overlay.get("data");
      const parent = data.parent; // 获取父级数据
      const startTime = Date.now();
      const duration = 400; // 动画时长
      let startPosition = [];
      let targetPosition = [];
      // 动画逻辑
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const fraction = Math.min(elapsed / duration, 1);
        const current = [
          startPosition[0] + fraction * (targetPosition[0] - startPosition[0]),
          startPosition[1] + fraction * (targetPosition[1] - startPosition[1]),
        ];
        overlay.setPosition(current);
        if (fraction < 1) {
          this.isMoving = true;
          requestAnimationFrame(animate);
        } else {
          this.isMoving = false;
          if (upOrDown === "up") {
            this.map.removeOverlay(overlay);
            this.moveCount++;
            if (this.moveCount === this.overlays.length) {
              this.updateOverlays(this.lastZoomLevel); // 更新 Overlay
            }
          }
        }
      };
      if (upOrDown === "down" && parent) {
        // startPosition.push(parent.longitude); // 父级位置
        startPosition = [parent.longitude, parent.latitude]; // 父级位置
        targetPosition = [data.longitude, data.latitude]; // 当前点位置
        animate();
      } else if (upOrDown === "up" && parent) {
        // startPosition.push(data.longitude); // 当前点位置
        startPosition = [data.longitude, data.latitude]; // 当前点位置
        targetPosition = [parent.longitude, parent.latitude]; // 父级位置
        animate();
      }
    },
    closeWindow() {
      if (this.currentPoint) {
        this.resetOvery(this.currentPoint, false);
        this.currentPoint = null;
      }
      if (this.winComent) {
        this.winComent.$el.parentNode.removeChild(this.winComent.$el);
        this.winComent = null;
      }
    },
    /**
     * 重置弹框overlay状态
     * @param info overlay信息
     * @param isCurent 是否被选中点位
     */
    resetOvery(info, isCurent = true) {
      if (info) {
        if (info.overlay) this.map.removeOverlay(info.overlay);
        const overlay = this.creatOverlay(info, isCurent);
        this.map.addOverlay(overlay);
        this.pointOverlays.push(overlay);
      }
    },
    /**
     * 弹框点击
     * @param obj 点位信息
     * @param tooltipCoord 点位位置
     * @param overlay 点位overlay
     */
    async openWindow(obj, tooltipCoord, overlay) {
      let isSpecial = false;
      this.isMoving = true;
      // 先把上次overlay重置为未选中
      if (this.currentPoint) await this.resetOvery(this.currentPoint, false);
      // 选中对象重置
      this.currentPoint = Object.assign(obj, { overlay: overlay });
      // 再把当前overlay设置为选中
      this.resetOvery(this.currentPoint);
      const Content = Vue.extend(infowindow);
      if (this.winComent) {
        this.winComent.$el.parentNode.removeChild(this.winComent.$el);
        this.winComent = null;
      }
      this.winComent = new Content({
        propsData: {
          detailInfo: obj,
          infoType: obj.queryType,
          vmm: this,
        },
      }).$mount();
      if (
        obj.queryType == 5 ||
        obj.queryType == 6 ||
        obj.queryType == "5,6" ||
        obj.queryType == "9"
      ) {
        isSpecial = true;
      } else {
        isSpecial = false;
      }
      this.winTooltip = new Overlay({
        element: this.winComent.$el,
        offset: isSpecial ? [26, 120] : [-30, 120],
        positioning: "center-left",
        insertFirst: true,
      });
      this.map.addOverlay(this.winTooltip);
      this.map.getView().animate({
        center: tooltipCoord,
        duration: 800,
      });
      this.winTooltip.setPosition(tooltipCoord);
      setTimeout(() => {
        // 点击详情会移动视图,这个时候不请求点位信息
        this.isMoving = false;
      }, 2000);
    },
    getPan() {
      let pan = null;
      this.map.getInteractions().forEach((element) => {
        if (element instanceof DragPan) {
          pan = element;
        }
      });
      return pan;
    },
    // 可联系农机
    getStationListByRadius(params) {
      return getStationListByRadius(params);
    },
    getPointList() {
      const center = this.map.getView().getCenter();
      let params = {
        queryTypes: (this.typeList || []).join(","),
        radius: 20000,
        latitude: center[1],
        longitude: center[0],
      };
      let arr = [this.getStationListByRadius(params)];
      Promise.all(arr).then((result) => {
        const list = (result || []).flat();
        this.setVehiclePoints(list);
      });
    },
    async clearPointOverlays() {
      this.pointOverlays.forEach((overlay) => {
        this.map.removeOverlay(overlay);
      });
      this.pointOverlays = [];
    },
    creatOverlay(dataItem, isCurent = false) {
      const Content = Vue.extend(pointWindow);
      let element = new Content({
        propsData: {
          isCurent: isCurent,
          infoType: dataItem.queryType,
          vmm: this,
        },
      }).$mount();
      const overlay = new Overlay({
        element: element.$el,
        position: [dataItem.longitude, dataItem.latitude],
        offset: [0, 10],
        stopEvent: false,
      });
      overlay.set("data", dataItem); // 将数据存储到 Overlay 中
      if (isCurent)
        this.currentPoint = Object.assign(dataItem, { overlay: overlay }); // 更新储存overlay
      // 解决overlay层级被遮挡问题
      overlay.getElement().addEventListener("mouseenter", (event) => {
        overlay.getElement().parentNode.style.zIndex = this.winZIndex += 10;
      });
      // 解决overlay层级被遮挡问题
      overlay.getElement().addEventListener("mouseleave", (event) => {
        overlay.getElement().parentNode.style.zIndex = this.winZIndex += 9;
      });
      overlay.getElement().addEventListener("click", (event) => {
        overlay.getElement().parentNode.style.zIndex = this.winZIndex += 11;
        this.openWindow(
          dataItem,
          [dataItem.longitude, dataItem.latitude],
          overlay
        );
      });
      return overlay;
    },
    /**
     * @description: 增加点位
     * @arr {Array} 点位数据
     * @return {void}
     */
    async setVehiclePoints(arr, isClear = true) {
      if (isClear) await this.clearPointOverlays();
      arr.forEach((dataItem, i) => {
        if (dataItem) {
          const isCurent =
            this.currentPoint &&
            dataItem.longitude == this.currentPoint.longitude &&
            dataItem.latitude == this.currentPoint.latitude
              ? true
              : false;
          const overlay = this.creatOverlay(dataItem, isCurent);
          this.map.addOverlay(overlay);
          this.pointOverlays.push(overlay);
        }
      });
    },
    /**
     * @description: 切换图层
     * @cityCode {String} 城市编码
     * @return {void}
     */
    async addProvince(city = "410000000") {
      console.log("city :>> ", city);
      let _this = this;
      let params = {
        areaCode: city,
        largeScreenType: "socialization",
      };
      this.mapSeting = await getMapSeting(params);
      // if (!GIS_MAP[city]) {
      if (!this.mapSeting || !this.mapSeting.specialEffectsUrl) {
        console.log("失败 :>> ", "未找到区域图层");
        this.map.removeLayer(this.layers.baseLayer);
        return;
      } else {
        this.map.getView().setZoom(this.mapSeting.zoom);
        this.map.getView().setCenter(this.mapSeting.center.split(","));
        // this.map.getView().setZoom(GIS_MAP[city].socializationZoom);
        // this.map.getView().setCenter(GIS_MAP[city].socializationCenter);
        this.map.removeLayer(this.layers.baseLayer);
        this.layers.baseLayer = new TileLayer({
          zIndex: 11,
          source: new TileSuperMapRest({
            // url: this.$utils.formatUrl(GIS_MAP[city].cooperativeUrl || GIS_MAP[city].url),
            url: _this.$utils.formatUrl(_this.mapSeting.specialEffectsUrl),
            cacheEnabled: true,
            overlapDisplayed: false,
          }),
          isGroup: true,
          name: "河南省卫星地图_",
          type: "baseLyer",
        });
        this.map.addLayer(this.layers.baseLayer);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@assets/css/var.scss";
.mapContainer {
  float: right;
  width: 100%;
  height: 100%;
  position: relative;
}
.ol-zoom.ol-unselectable.ol-control {
  display: none;
}
.map {
  width: 100%;
  height: 100%;
}
.ol-rotate {
  display: none;
}
</style>
